import React from 'react';
import { Field, Text, RadioGroup, SectionShell } from './FormControls';

const HeaderSection = ({ data, update, certificateNumberReadOnly = false }) => (
  <SectionShell title="Installation / Header" description="Depot and installation details">
    <Field label="Document Type" required>
      <RadioGroup
        name="documentType"
        value={data.documentType}
        onChange={(v) => update('documentType', v)}
        options={[
          { value: 'inspection', label: 'Inspection' },
          { value: 'report', label: 'Report' },
          { value: 'certificate', label: 'Certificate' },
        ]}
      />
    </Field>
    <Field label="Depot Name" required>
      <Text value={data.customerName} onChange={(v) => update('customerName', v)} required />
    </Field>
    <Field label="Depot Address" required>
      <Text value={data.installationAddress} onChange={(v) => update('installationAddress', v)} required />
    </Field>
    <Field label="Delivery Point Code" required>
      <Text value={data.deliveryPointCode} onChange={(v) => update('deliveryPointCode', v)} required />
    </Field>
    <Field label="Certificate Number" required>
      <Text
        value={data.certificateNumber}
        onChange={(v) => update('certificateNumber', v)}
        required
        readOnly={certificateNumberReadOnly}
        placeholder={certificateNumberReadOnly ? 'Assigned automatically' : undefined}
      />
      {certificateNumberReadOnly && (
        <p className="text-pvs-text-dim text-xs mt-1">
          Assigned from the admin-configured certificate number range on successful submission.
        </p>
      )}
      {!certificateNumberReadOnly && (
        <p className="text-pvs-text-dim text-xs mt-1">
          Enter manually while certificate numbering is disabled for testing.
        </p>
      )}
    </Field>
    <Field label="WSE Reference" required hint="Auto-filled from the examination type.">
      <Text value={data.wseReference} onChange={(v) => update('wseReference', v)} readOnly />
    </Field>
    <Field label="Examination Type" required>
      <RadioGroup
        name="examinationType"
        value={data.examinationType}
        onChange={(v) => update('examinationType', v)}
        options={[
          { value: 'annual', label: 'Annual' },
          { value: 'inService', label: 'In-Service' },
          { value: 'thorough', label: 'Thorough' },
        ]}
      />
    </Field>
    <Field label="Installation Category" required>
      <RadioGroup
        name="installationCategory"
        value={data.installationCategory}
        onChange={(v) => update('installationCategory', v)}
        options={[
          { value: 'Domestic', label: 'Domestic' },
          { value: 'Commercial', label: 'Commercial' },
        ]}
      />
    </Field>
    <Field label="Vessel Type" required>
      <RadioGroup
        name="vesselType"
        value={data.vesselType}
        onChange={(v) => update('vesselType', v)}
        options={[
          { value: 'aboveground', label: 'Aboveground' },
          { value: 'underground', label: 'Underground' },
        ]}
      />
    </Field>
    <Field label="Installation Use" required>
      <RadioGroup
        name="installationUse"
        value={data.installationUse}
        onChange={(v) => update('installationUse', v)}
        options={[
          { value: 'Vapour', label: 'Vapour' },
          { value: 'Liquid', label: 'Liquid' },
          { value: 'Both', label: 'Both' },
        ]}
      />
    </Field>
  </SectionShell>
);

export default HeaderSection;
